export default (settings: any) => {
  if (settings['extendedEditForms'] === false) {
    return 0
  }
  return 1 / 6 + (settings['entities'] * (1 / 60) * 15) + (settings['columns'] * (1 / 60) * 5)
}
